import { ReactNode } from 'react';
import dynamic from 'next/dynamic';
import { usePage } from '~/services/cms';
import { Tracking } from '~/tracking';

const layouts = {
  standard: dynamic(() => import('./layouts/standard')),
  p100CheckoutPage: dynamic(() => import('./layouts/checkout')),
};

const PAGE_TYPE_FALLBACK = "P060StandardPage"

function getLayout(pageType: string | undefined) {
  switch (pageType) {
    case 'p100CheckoutPage':
      return layouts.p100CheckoutPage;
    case PAGE_TYPE_FALLBACK:
    default:
      return layouts.standard;
  }
}

export function DynamicLayout({ children }: { children: ReactNode }) {
  const { data: page } = usePage();
  const Layout = getLayout(page?.type);

  return (
    <Layout>{children}
      <Tracking pageType={page?.type ?? PAGE_TYPE_FALLBACK} />
    </Layout>
  );
}
